function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3d5564;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -15.989)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 15.989)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M20.612,18.65H11.968V16.655a.663.663,0,0,0-.241-.512A.653.653,0,0,0,11.181,16L.543,18A.663.663,0,0,0,0,18.65V33.278a.664.664,0,0,0,.543.653l10.638,1.995a.625.625,0,0,0,.122.012.665.665,0,0,0,.665-.665V33.278h8.644a.665.665,0,0,0,.665-.665v-13.3A.665.665,0,0,0,20.612,18.65ZM9.144,28.186a.664.664,0,1,1-1,.875L6.21,26.852l-1.7,2.181a.666.666,0,0,1-1.051-.818l1.854-2.383-1.828-2.09a.665.665,0,0,1,1-.875l1.66,1.9L8.12,22.231a.665.665,0,0,1,1.049.818L7.041,25.783Zm10.8,3.762H11.968v-1.33h1.995a.665.665,0,1,0,0-1.33H11.968v-1.33h1.995a.665.665,0,1,0,0-1.33H11.968V25.3h1.995a.665.665,0,1,0,0-1.33H11.968v-1.33h1.995a.665.665,0,1,0,0-1.33H11.968V19.98h7.979Z",
  transform: "translate(0 -15.989)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.957 21.309)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M385.995,144.011h-1.33a.665.665,0,0,0,0,1.33h1.33a.665.665,0,0,0,0-1.33Z",
  transform: "translate(-384 -144.011)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.957 23.969)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M385.995,208.011h-1.33a.665.665,0,0,0,0,1.33h1.33a.665.665,0,0,0,0-1.33Z",
  transform: "translate(-384 -208.011)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.957 26.629)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M385.995,272.011h-1.33a.665.665,0,0,0,0,1.33h1.33a.665.665,0,0,0,0-1.33Z",
  transform: "translate(-384 -272.011)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.957 29.288)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M385.995,336.011h-1.33a.665.665,0,0,0,0,1.33h1.33a.665.665,0,1,0,0-1.33Z",
  transform: "translate(-384 -336.011)"
})));

var SvgExcel = function SvgExcel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.277,
    height: 19.948,
    viewBox: "0 0 21.277 19.948",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excel.31571b8d.svg";
export { ForwardRef as ReactComponent };